<template>
  <div class="flex items-center gap-3 mb-4">
    <div class="flex rounded border border-gray-200 overflow-hidden text-sm">
      <button
        v-for="opt in statusOptions"
        :key="opt.value"
        @click="$emit('update:status', opt.value)"
        class="px-3 py-1.5 font-medium transition-colors"
        :class="status === opt.value
          ? 'bg-teal-600 text-white'
          : 'bg-white text-gray-600 hover:bg-gray-50'"
      >
        {{ opt.label }}
        <span v-if="opt.value === 'fresh' && freshCount > 0"
          class="ml-1 text-xs px-1.5 py-0.5 rounded-full"
          :class="status === 'fresh' ? 'bg-teal-700 text-teal-100' : 'bg-gray-100 text-gray-600'"
        >{{ freshCount }}</span>
      </button>
    </div>

    <div class="flex-1">
      <input
        type="text"
        :value="search"
        @input="$emit('update:search', $event.target.value)"
        placeholder="Search ideas..."
        class="w-full text-sm rounded border border-gray-200 px-3 py-1.5 text-gray-800 placeholder-gray-400
               focus:border-teal-500 focus:ring-1 focus:ring-teal-500 outline-none"
      />
    </div>
  </div>
</template>

<script setup>
defineProps({
  status: String,
  search: String,
  freshCount: { type: Number, default: 0 },
})

defineEmits(['update:status', 'update:search'])

const statusOptions = [
  { value: 'fresh', label: 'Fresh' },
  { value: 'used', label: 'Used' },
  { value: 'all', label: 'All' },
]
</script>
